import { COMMON_WAIFUS, getCommonReviews } from '../../../constants.js';

export const HI_BASE = {
    hero: {
      title: "Waifu Briscola",
      tagline: "Briscola जैसा आपने पहले कभी नहीं देखा: RPG, Waifu और AI.",
      ctaWeb: "वेब पर खेलें",
      ctaAndroid: "Android के लिए डाउनलोड करें",
      version: "वर्जन 2.3",
      badge: "✨ नया कालकोठरी मोड"
    },
    stats: {
      downloads: "डाउनलोड",
      downloadsValue: ["गिन नहीं सकते!", "सर्वर फुल", "बहुत सारा!", "9000 से अधिक", "गिनने के लिए बहुत ज्यादा"],
      hands: "हारे हुए हाथ",
      handsValue: ["बहुत ज्यादा...", "कौशल की कमी", "लैग की गलती", "क्या आप अभी भी रो रहे हैं?", "पुनः प्रयास करें आप भाग्यशाली होंगे"],
      rating: "रेटिंग",
      ratingValue: ["दादी की मंजूरी", "11/10 - IGN", "पिज्जा से बेहतर", "GOTY 2026", "उत्कृष्ट कृति"],
      waifus: "Waifu",
      waifusValue: ["सब तुम्हारे लिए", "केवल 2D > 3D", "उन सभी को ले लीजिए!", "Waifu > Meta", "सच्चा खजाना"]
    },
    features: {
      title: "सिर्फ एक कार्ड गेम से कहीं अधिक",
      items: [
        { id: "classic", title: "क्लासिक Briscola", description: "मूल अनुभव, उत्तम और स्वच्छ।", icon: "🃏" },
        { id: "roguelike", title: "Roguelike RPG", description: "टॉवर पर चढ़ें, तात्विक शक्तियाँ प्राप्त करें और बॉस को हराएं।", icon: "⚔️" },
        { id: "ai", title: "जीवित AI", description: "Google Gemini की बदौलत, विरोधी वास्तविक समय में आपका अपमान या प्रशंसा करते हैं।", icon: "🧠" },
        { id: "gacha", title: "गचा सिस्टम", description: "नई खाल और दुर्लभ पृष्ठभूमि अनलॉक करने के लिए सिक्कों का उपयोग करें।", icon: "💎" },
        { id: "dungeon", title: "कालकोठरी मोड", description: "पागल नियमों के साथ बॉस का सामना करें। एक हार और खेल खत्म।", icon: "🏰" },
        { id: "puzzle", title: "पहेली मोड", description: "विशिष्ट लक्ष्यों के साथ जटिल परिदृश्यों को हल करें।", icon: "🧩" }
      ]
    },
    video: { title: "गेमप्ले ट्रेलर" },
    waifus: {
      title: "अपना साथी चुनें",
      subtitle: "प्रत्येक चरित्र का एक अनूठा व्यक्तित्व, डबिंग और खेल शैली है।",
      characters: [
        { ...COMMON_WAIFUS[0], name: "Miu", role: "मीठी", personality: "मीठी और धूप जैसी, आपके पास रहना पसंद करती है।" },
        { ...COMMON_WAIFUS[1], name: "Rei", role: "विश्लेषक", personality: "गणना करने वाली और ठंडी। केवल तर्क।" },
        { ...COMMON_WAIFUS[2], name: "Akame", role: "Tsundere", personality: "प्रतिस्पर्धी और उग्र। हारना नफरत है।" },
        { ...COMMON_WAIFUS[3], name: "Lilith", role: "रानी", personality: "ताश की अंधेरी रानी।" },
        { ...COMMON_WAIFUS[4], name: "Mochi", role: "गाइड", personality: "आपकी भरोसेमंद गाइड... शायद।" }
      ]
    },
    reviews: {
      title: "वे हमारे बारे में कहते हैं (दुर्भाग्य से)",
      items: getCommonReviews('hi')
    },
    ctaStrip: {
      title: "मैदान में उतरने के लिए तैयार?",
      subtitle: "अन्य खिलाड़ियों के साथ जुड़ें और आज ही अपना रोमांच शुरू करें।",
      button: "अब खेलना शुरू करें"
    },
    footer: { privacy: "गोपनीयता", terms: "शर्तें", copyright: "© 2026 Waifu Briscola" },
    privacy: {
      title: "Waifu Briscola गोपनीयता नीति",
      lastUpdated: "अंतिम अपडेट: 25 मई 2024",
      intro: "यह गोपनीयता नीति बताती है कि जब आप Waifu Briscola एप्लिकेशन ('सेवा') का उपयोग करते हैं तो आपकी जानकारी कैसे प्रबंधित की जाती है।",
      sections: [
        {
          title: "जानकारी जो हम एकत्र करते हैं",
          intro: "आपके अनुभव को बेहतर बनाने के लिए, हम तृतीय-पक्ष सेवाओं का उपयोग करते हैं जो जानकारी एकत्र कर सकती हैं:",
          items: [
            "उपयोग डेटा (PostHog): हम गेम के साथ आपके इंटरैक्ट करने के तरीके के बारे में अनाम या छद्म नामी एनालिटिक्स डेटा एकत्र करते हैं। इसमें गेम शुरू होना, खेले गए कार्ड और अंतिम परिणाम जैसी घटनाएं शामिल हैं। यह डेटा हमें यह समझने में मदद करता है कि गेम का उपयोग कैसे किया जाता है और हम इसे कैसे सुधार सकते हैं। हम PostHog के माध्यम से व्यक्तिगत पहचान योग्य जानकारी (PII) एकत्र नहीं करते हैं।",
            "AI इंटरैक्शन (Google Gemini): आपके द्वारा भेजे गए चैट संदेश और गेम की स्थिति (जैसे आपके हाथ में और टेबल पर कार्ड) के बारे में जानकारी AI की प्रतिक्रियाओं और चालों को उत्पन्न करने के लिए Google Gemini API को भेजी जाती है। ये इंटरैक्शन Google की गोपनीयता नीति के अधीन हैं। हम आपकी गेम इंटरैक्शन सामग्री के अलावा Google को कोई व्यक्तिगत जानकारी नहीं भेजते हैं।",
          ],
        },
        {
          title: "हम आपकी जानकारी का उपयोग कैसे करते हैं",
          intro: "हम एकत्र की गई जानकारी का उपयोग करते हैं:",
          items: [
            "हमारी सेवा प्रदान करने, संचालित करने और बनाए रखने के लिए।",
            "हमारी सेवा में सुधार, वैयक्तिकरण और विस्तार करने के लिए।",
            "यह समझने और विश्लेषण करने के लिए कि आप हमारी सेवा का उपयोग कैसे करते हैं।",
            "दुरुपयोग को रोकने और सुरक्षा सुनिश्चित करने के लिए।",
          ],
        },
        {
          title: "जानकारी साझा करना",
          body: "हम आपकी व्यक्तिगत जानकारी किसी के साथ साझा नहीं करते हैं, सिवाय एप्लिकेशन के संचालन के लिए आवश्यक तृतीय-पक्ष सेवा प्रदाताओं (PostHog, Google) के, जैसा कि ऊपर बताया गया है।",
        },
        {
          title: "डेटा सुरक्षा",
          body: "आपकी जानकारी की सुरक्षा हमारे लिए महत्वपूर्ण है, लेकिन याद रखें कि इंटरनेट पर प्रसारण का कोई भी तरीका या इलेक्ट्रॉनिक भंडारण का तरीका 100% सुरक्षित नहीं है।",
        },
        {
          title: "इस गोपनीयता नीति में परिवर्तन",
          body: "हम समय-समय पर अपनी गोपनीयता नीति अपडेट कर सकते हैं। हम आपको इस पृष्ठ पर नई गोपनीयता नीति पोस्ट करके किसी भी बदलाव के बारे में सूचित करेंगे।",
        },
        {
          title: "संपर्क करें",
          body: "यदि आपके पास इस गोपनीयता नीति के बारे में कोई प्रश्न हैं, तो आप प्रभारी व्यक्ति Mauro Mazzocchetti से संपर्क कर सकते हैं।",
        },
      ],
    },
    consent: { text: "हम साइट को बेहतर बनाने के लिए कुकीज़ और एनालिटिक्स का उपयोग करते हैं। जारी रखकर आप स्वीकार करते हैं हमारी", ok: "समझ गया" },
    terms: {
      title: "Waifu Briscola नियम और शर्तें",
      lastUpdated: "अंतिम अपडेट: 25 मई 2024",
      contact: "प्रभारी व्यक्ति: Mauro Mazzocchetti",
      intro: "Waifu Briscola में आपका स्वागत है! ये नियम और शर्तें Waifu Briscola एप्लिकेशन ('सेवा') के उपयोग के नियमों को रेखांकित करती हैं।",
      sections: [
        {
          title: "शर्तों की स्वीकृति",
          body: "इस सेवा तक पहुँचने और उपयोग करने से, आप इन शर्तों से बंधे होने के लिए सहमत हैं। यदि आप शर्तों के किसी भी भाग से असहमत हैं, तो आप सेवा का उपयोग नहीं कर सकते हैं।",
        },
        {
          title: "सेवा का उपयोग",
          body: "आप सहमत हैं कि सेवा का उपयोग किसी भी अवैध या अनधिकृत उद्देश्य के लिए नहीं करेंगे। आप अपने आचरण और सेवा का उपयोग करते समय आपके द्वारा प्रदान की जाने वाली किसी भी सामग्री, जिसमें चैट संदेश शामिल हैं, के लिए जिम्मेदार हैं।",
        },
        {
          title: "AI-जनित सामग्री",
          intro: "सेवा प्रतिक्रियाएं, टिप्पणियां और गेम की चालें उत्पन्न करने के लिए कृत्रिम बुद्धिमत्ता मॉडल (Google Gemini) का उपयोग करती है। आप स्वीकार करते हैं कि:",
          items: [
            "AI-जनित सामग्री एक मॉडल द्वारा निर्मित होती है और हमेशा सटीक, उपयुक्त या सुसंगत नहीं हो सकती है।",
            "हम AI-जनित सामग्री के लिए जिम्मेदार नहीं हैं।",
            "AI के साथ इंटरैक्शन केवल मनोरंजन के उद्देश्यों के लिए हैं।",
          ],
        },
        {
          title: "दायित्व की सीमा",
          body: "किसी भी स्थिति में Mauro Mazzocchetti या उनके भागीदार किसी भी अप्रत्यक्ष, आकस्मिक, विशेष, परिणामी या दंडात्मक नुकसान के लिए उत्तरदायी नहीं होंगे, जिसमें बिना किसी सीमा के, लाभ, डेटा, सद्भावना या अन्य अमूर्त नुकसान शामिल हैं, जो (i) आपकी सेवा तक पहुंच या उपयोग या पहुंच या उपयोग करने में असमर्थता; (ii) सेवा से प्राप्त कोई भी सामग्री से उत्पन्न होते हैं।",
        },
        {
          title: "शर्तों में परिवर्तन",
          body: "हम किसी भी समय अपने विवेकाधिकार पर इन शर्तों को संशोधित करने या बदलने का अधिकार सुरक्षित रखते हैं। हम आपको इस पृष्ठ पर नई शर्तें पोस्ट करके किसी भी बदलाव के बारे में सूचित करेंगे।",
        },
        {
          title: "शासी कानून",
          body: "ये शर्तें कानून के संघर्ष के प्रावधानों की परवाह किए बिना इतालवी कानूनों के अनुसार शासित और मानी जाएंगी।",
        },
      ],
    }
};
